module.exports = __webpack_public_path__ + "static/media/logo.3b5eb0e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 453
// module chunks = 0